






























import { NewObject } from "@/helper/shareHelper";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class SectionReceivedTaxInvoice extends Vue {
  @Prop({}) readonly transactionCreate!: any;
  private checked = false;
  private purchaseTaxInvoiceDateValue: any = null;
  private purchaseTaxInvoiceNumberValue: any = "";
  private inputValidateReceivedNumberBasicError = false;

  @Watch("checked")
  checkedChanged() {
    if (!this.checked) {
      this.purchaseTaxInvoiceNumberValue = "";
      this.inputValidateReceivedNumberBasicError = false;
      this.purchaseTaxInvoiceDateValue = "";
      this.ClearReceivedTaxInvoice();
    } else {
      if (!this.purchaseTaxInvoiceDateValue) {
        this.purchaseTaxInvoiceDateValue = new Date(this.transactionCreate.date.value);
        this.purchaseTaxInvoiceDateValue = this.purchaseTaxInvoiceDateValue.ToDateJsonString();
      }
    }
  }

  public RegisterReceivedTaxInvoice() {
    if (this.purchaseTaxInvoiceDateValue && this.purchaseTaxInvoiceNumberValue) {
      this.DoSelectedReceivedTaxInvoice();
    } else {
      this.ClearReceivedTaxInvoice();
    }
  }

  public DoSelectedReceivedTaxInvoice() {
    const purchaseTaxInvoiceNumberValidateError = this.purchaseTaxInvoiceNumberValue
      ? this.purchaseTaxInvoiceNumberValue.length > 35
      : false;
    if (
      this.purchaseTaxInvoiceNumberValue &&
      !purchaseTaxInvoiceNumberValidateError &&
      this.purchaseTaxInvoiceDateValue
    ) {
      this.transactionCreate.receivedTaxInvoice.value = [];
      this.transactionCreate.receivedTaxInvoice.value.push({
        receivedTaxInvoiceNumber: this.purchaseTaxInvoiceNumberValue,
        receivedTaxInvoiceDate: this.purchaseTaxInvoiceDateValue,
        preVatTotal: this.transactionCreate.transactionSummary.vat.preVatTotal.ToNumber(),
        vatTotal: this.transactionCreate.transactionSummary.vat.vatTotal.ToNumber(),
        netAmount:
          this.transactionCreate.transactionSummary.vat.preVatTotal.ToNumber() +
          this.transactionCreate.transactionSummary.vat.vatTotal.ToNumber(),
      });
      this.$emit("update:showModal", false);
    } else if (!this.purchaseTaxInvoiceNumberValue || purchaseTaxInvoiceNumberValidateError) {
      this.inputValidateReceivedNumberBasicError = true;
      return;
    }
  }
  public ClearReceivedTaxInvoice() {
    this.transactionCreate.receivedTaxInvoice.value = [];
  }
}
